import {
  AnnotationListSideload,
  AnnotationSearch,
} from '@rossum/api-client/annotations';
import {
  AnnotationListColumn,
  AnnotationListColumns,
  MetaField,
  SchemaColumn,
} from '@rossum/api-client/shared';
import { ListResponse } from '@rossum/api-client/utils';
import { SCHEMA_COLUMN_PREFIX } from '../document-list-base/schemaColumnPrefix';

export const DEFAULT_COLUMN_WIDTH = 120;

export type DashboardAnnotationListWithSideload =
  ListResponse<AnnotationSearch> &
    // These are always present
    Pick<AnnotationListSideload, 'relations' | 'documents' | 'childRelations'> &
    // These are present if relevant
    Partial<
      Pick<
        AnnotationListSideload,
        | 'assignees'
        | 'labels'
        | 'modifiers'
        | 'exportedBys'
        | 'deletedBys'
        | 'rejectedBys'
        | 'confirmedBys'
        | 'creators'
        | 'workflowRuns'
        | 'workflowSteps'
      >
    >;

export const getColumnField = <
  T extends {
    columnType: AnnotationListColumn['columnType'];
    field: string;
    dataType?: SchemaColumn['dataType'];
  },
>(
  c: T
) =>
  `${c.columnType === 'schema' ? SCHEMA_COLUMN_PREFIX : c.columnType}.${c.field}.${
    c.dataType ?? ''
  }`;

export const filterSchemaColumns = (columns: AnnotationListColumns) =>
  columns.flatMap(col => (col.columnType === 'schema' ? [col] : []));

export const filterMetaColumns = (columns: AnnotationListColumns) =>
  columns.flatMap(col => (col.columnType === 'meta' ? [col] : []));

export const getColumnName = (column: AnnotationListColumn) =>
  column.columnType === 'meta' ? column.metaName : column.schemaId;

export const metaColumnsMap = {
  annotation: 'annotation',
  assignees: 'assignees',
  queue: 'queue',
  status: 'status',
  assigned_at: 'assigned_at',
  original_file_name: 'original_file_name',
  labels: 'labels',
  details: 'details',
  relations: 'relations',
  created_at: 'created_at',
  modified_at: 'modified_at',
  exported_at: 'exported_at',
  confirmed_at: 'confirmed_at',
  rejected_at: 'rejected_at',
  deleted_at: 'deleted_at',
  modifier: 'modifier',
  exported_by: 'exported_by',
  confirmed_by: 'confirmed_by',
  rejected_by: 'rejected_by',
  deleted_by: 'deleted_by',
  export_failed_at: 'export_failed_at',
  creator: 'creator',
  training_enabled: 'training_enabled',
  workflow_step: 'workflow_step',
} as const satisfies Record<MetaField, MetaField>;
